import { Banner, Button } from "rothzerg-ui";

export function FeedbackBanner() {
  return (
    <div id="feedback-banner" className="kmart-section--muted" style={{ padding: "1rem 0" }}>
      <Banner
        variant="info"
        message="We would love to hear what you think of this page"
        dismissible={false}
      >
        <Button id="give-feedback" variant="default" size="sm">
          Give Feedback
        </Button>
      </Banner>
    </div>
  );
}
